import { PropsWithChildren, useEffect, useState } from 'react';
import { ScrollRestoration, useLocation } from 'react-router-dom';
import PageLoadingState from '@/routes/PageLoadingState';

export const AnimationStage = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (location?.pathname !== displayLocation?.pathname) {
      setIsVisible(false);
      setDisplayLocation(location);

      setTimeout(() => {
        setIsVisible(true);
      }, 600);
    }
  }, [location, displayLocation]);

  return !isVisible ? (
    <PageLoadingState />
  ) : (
    <div>
      {children}
      <ScrollRestoration></ScrollRestoration>
    </div>
  );
};

export default AnimationStage;
